import { FormikProvider, useFormik } from 'formik';
import { useEffect } from 'react';

import CustomButton from '@perpay-web/components/base/CustomButton/CustomButton';
import NonFieldErrors from '@perpay-web/components/base/NonFieldErrors/NonFieldErrors';
import FormikTextInput from '@perpay-web/components/base/TextInput/FormikTextInput';
import FocusContent from '@perpay-web/components/composite/FocusLayout/FocusContent';
import FocusFooter from '@perpay-web/components/composite/FocusLayout/FocusFooter';
import FocusLayout from '@perpay-web/components/composite/FocusLayout/FocusLayout';
import Stack from '@perpay-web/components/design-system/Stack/Stack';
import { formatMaskedPhoneNumber } from '@perpay-web/utils/stringUtils';
import { phoneVerification } from '@perpay-web/validators/formBased';

import styles from './UserVerificationModal.scss';

const VerifyPhoneNumberStep = ({
    initialValues = {
        code: '',
    },
    verifyPhoneNumber,
    mobilePhone,
    onResend,
    loading,
    errors,
    onHelpButtonClick,
    onLoadPageView,
}) => {
    useEffect(() => {
        if (onLoadPageView) {
            onLoadPageView();
        }
    }, [onLoadPageView]);

    const formik = useFormik({
        initialValues,
        onSubmit: verifyPhoneNumber,
        validate: phoneVerification,
    });

    return (
        <div className={styles['modal-content']}>
            <FormikProvider value={formik}>
                <form onSubmit={formik.handleSubmit}>
                    <FocusLayout
                        className={styles['focus-layout']}
                        shouldResetScroll={false}
                    >
                        <FocusContent className={styles['form-focus-layout']}>
                            <div>
                                <div className={styles['step-subtitle']}>
                                    Final Step
                                </div>
                                <Stack className={styles.description}>
                                    <div className={styles.title}>
                                        Verify your phone number
                                    </div>
                                    <div className={styles.subtitle}>
                                        We sent a code to&nbsp;
                                        <span>
                                            {formatMaskedPhoneNumber(
                                                mobilePhone,
                                            )}
                                        </span>
                                        .
                                    </div>
                                </Stack>
                                <FormikTextInput
                                    className={
                                        styles['verification-code-input']
                                    }
                                    label='Verification code'
                                    name='code'
                                    type='tel'
                                    maxLength='4'
                                />
                                <CustomButton
                                    action='inline-link'
                                    onClick={onResend}
                                >
                                    Resend code
                                </CustomButton>
                                <NonFieldErrors errors={errors} />
                            </div>
                        </FocusContent>
                        <FocusFooter className={styles['modal-footer']}>
                            <CustomButton
                                action='primary'
                                loading={loading}
                                type='submit'
                            >
                                Verify
                            </CustomButton>
                            <CustomButton
                                action='link'
                                type='button'
                                className={styles['button-link']}
                                onClick={onHelpButtonClick}
                            >
                                Get help
                            </CustomButton>
                        </FocusFooter>
                    </FocusLayout>
                </form>
            </FormikProvider>
        </div>
    );
};

export default VerifyPhoneNumberStep;
